var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhyIlustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4348 314.44C20.4348 314.44 -9.08969 252.911 7.52109 192.622C24.1319 132.334 83.8008 43.7527 135.478 35.7535C187.155 27.7544 209.913 42.5203 244.979 80.6639C280.046 118.807 331.715 124.954 344.024 160.633C356.333 196.312 326.181 245.524 316.949 273.824C307.718 302.124 312.035 337.19 312.035 337.19H30.2788L20.4348 314.44Z",
    fill: "url(#paint0_linear_575_71672)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.4348 314.44C20.4348 314.44 -9.08969 252.911 7.52109 192.622C24.1319 132.334 83.8008 43.7527 135.478 35.7535C187.155 27.7544 209.913 42.5203 244.979 80.6639C280.046 118.807 331.715 124.954 344.024 160.633C356.333 196.312 326.181 245.524 316.949 273.824C307.718 302.124 312.035 337.19 312.035 337.19H30.2788L20.4348 314.44Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 332.29H19.9119L18.814 145.718H13.6679L12.5625 332.29Z",
    fill: "#215AAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5084 144.814H22.4437L23.9375 127.285H9.01465L10.5084 144.814Z",
    fill: "#F2EC91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8379 144.814H21.1067L22.2644 127.285H10.6802L11.8379 144.814Z",
    fill: "url(#paint1_linear_575_71672)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75233 128.592H25.1025V125.671H7.75233V128.592Z",
    fill: "#215AAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12657 146.517H23.7432V142.91H9.12657V146.517Z",
    fill: "#215AAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2916 125.671H22.7646V123.722H10.2916V125.671Z",
    fill: "#215AAE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7368 123.737H17.8804V120.817H15.7368V123.737Z",
    fill: "#215AAE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61957 336.846H22.5557L22.5557 321.147H9.61957L9.61957 336.846Z",
    fill: "#215AAE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4238 54.5228C53.064 53.3275 54.112 52.4017 55.3772 51.9137C56.6423 51.4257 58.0405 51.4081 59.3176 51.8639C59.6526 50.3557 60.4357 48.984 61.5641 47.9287C62.6924 46.8735 64.1134 46.1839 65.6406 45.9505C67.1678 45.7171 68.7299 45.9508 70.122 46.6208C71.514 47.2909 72.6711 48.3661 73.4413 49.7054C74.8979 47.9056 76.9107 46.6402 79.164 46.1076C81.4173 45.5751 83.7836 45.8055 85.8919 46.7626C85.0158 45.3002 84.5997 43.6081 84.6977 41.9061C84.7957 40.2042 85.4032 38.571 86.4413 37.2188C87.4795 35.8665 88.9002 34.8577 90.5191 34.3234C92.138 33.789 93.8801 33.7538 95.5193 34.2224C95.5193 33.834 95.4745 33.4755 95.4745 33.0423C95.5716 28.2109 97.5592 23.6101 101.01 20.2276C104.462 16.8452 109.101 14.9506 113.934 14.9506C118.766 14.9506 123.406 16.8452 126.857 20.2276C130.308 23.6101 132.296 28.2109 132.393 33.0423C132.395 33.6735 132.362 34.3043 132.296 34.9319C134.478 33.6104 136.961 32.8663 139.51 32.77C142.059 32.6736 144.591 33.2281 146.866 34.3812C149.142 35.5343 151.086 37.248 152.516 39.3606C153.946 41.4733 154.814 43.9153 155.039 46.4564C156.159 45.5264 157.521 44.9345 158.965 44.7497C160.409 44.5649 161.876 44.795 163.194 45.413C164.513 46.031 165.628 47.0114 166.409 48.2397C167.191 49.468 167.607 50.8934 167.609 52.3494",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99902 104.28C8.51004 103.328 9.34569 102.59 10.3543 102.201C11.3629 101.812 12.4776 101.797 13.4961 102.159C13.7605 100.954 14.3839 99.8565 15.2842 99.0121C16.1844 98.1677 17.3193 97.6158 18.5393 97.429C19.7594 97.2422 21.0074 97.4294 22.119 97.9658C23.2306 98.5022 24.1537 99.3627 24.7667 100.434C25.9331 99.0036 27.5409 98.0004 29.3384 97.5814C31.1359 97.1625 33.0216 97.3514 34.7003 98.1187C34.0084 96.9523 33.6821 95.6054 33.7634 94.2518C33.8448 92.8981 34.3301 91.5999 35.1567 90.5249C35.9833 89.4498 37.1132 88.6473 38.4005 88.2209C39.6878 87.7945 41.0734 87.7638 42.3783 88.1328C42.3783 87.8265 42.3783 87.5128 42.3783 87.1917C42.4649 83.3438 44.0544 79.6827 46.8064 76.992C49.5584 74.3013 53.2543 72.7947 57.1032 72.7947C60.952 72.7947 64.648 74.3013 67.4 76.992C70.152 79.6827 71.7414 83.3438 71.8281 87.1917C71.8281 87.707 71.8281 88.2075 71.7534 88.6855C73.489 87.6302 75.465 87.0347 77.4946 86.9553C79.5243 86.8759 81.5408 87.3152 83.3535 88.2317C85.1663 89.1481 86.7155 90.5115 87.8549 92.1931C88.9943 93.8747 89.6863 95.819 89.8654 97.8423C90.7592 97.1007 91.8456 96.6288 92.9976 96.4818C94.1497 96.3349 95.3198 96.5189 96.3711 97.0125C97.4224 97.506 98.3115 98.2886 98.9344 99.2688C99.5573 100.249 99.8883 101.386 99.8887 102.548",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9112 289.591H143.873V284.729H36.9112V289.591Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9112 297.657H143.873V292.795H36.9112V297.657Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9112 305.716H143.873V300.854H36.9112V305.716Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9112 313.783H143.873V308.92H36.9112V313.783Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.295 317.554L148.347 336.719H146.853L144.202 318.212L148.295 317.554Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.573 317.554L141.625 336.719H140.131L137.48 318.212L141.573 317.554Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9746 317.554L31.9224 336.719H33.4161L36.0676 318.212L31.9746 317.554Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6963 317.554L38.644 336.719H40.1378L42.7893 318.212L38.6963 317.554Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8159 318.6H150.976V313.82H29.8159V318.6Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.816 313.947H32.5571V299.009H29.816V313.947Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8161 300.854H36.4111V299.009H29.8161V300.854Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.976 299.002H148.235V313.939H150.976V299.002Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.969 299.002H144.374V300.846H150.969V299.002Z",
    fill: "#215AAE",
    stroke: "#215AAE",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M236.248 202.929C236.248 202.593 236.495 202.339 236.741 202.399L250.798 205.387C251.29 205.491 251.492 204.565 251.029 204.304L236.838 196.312C236.747 196.25 236.675 196.165 236.629 196.065C236.582 195.965 236.565 195.854 236.577 195.744C237.167 185.534 238.071 174.339 239.266 162.881C239.266 162.56 239.527 162.336 239.766 162.403L252.202 165.585C252.657 165.705 252.904 164.905 252.523 164.562L240.52 153.665C240.451 153.59 240.399 153.502 240.368 153.405C240.337 153.308 240.328 153.205 240.341 153.105C240.983 147.585 241.693 142.073 242.447 136.636L243.426 131.198C243.493 130.862 243.762 130.676 244.008 130.81L251.246 134.798C251.671 135.037 252.037 134.313 251.709 133.88L244.501 124.275C244.449 124.199 244.412 124.114 244.393 124.024C244.374 123.935 244.372 123.842 244.389 123.752C245.831 114.789 247.422 106.305 249.139 98.649C249.214 98.2904 249.528 98.1411 249.767 98.3353L259.17 106.058C259.566 106.379 260.007 105.744 259.738 105.244L251.522 89.9328C251.442 89.7706 251.423 89.5848 251.47 89.41C252.717 84.5312 254.259 79.7324 256.086 75.0398C256.099 74.9839 256.126 74.9319 256.163 74.8876C256.199 74.8434 256.246 74.8081 256.298 74.7843C256.351 74.7606 256.408 74.7491 256.466 74.7507C256.523 74.7522 256.58 74.7668 256.631 74.7934L263.106 78.5875C263.442 78.7817 263.793 78.3635 263.681 77.9004L261.65 69.7369C261.65 69.595 261.471 68.99 261.314 68.4672L260.783 66.3685C262.277 64.5162 263.823 63.5079 265.392 63.5079C266.96 63.5079 268.708 64.6506 270.314 66.7494L267.901 77.9004C267.789 78.3635 268.14 78.7817 268.476 78.5875L274.295 75.1743C274.346 75.1478 274.403 75.1332 274.461 75.1316C274.519 75.1301 274.577 75.1415 274.63 75.1652C274.683 75.1888 274.73 75.224 274.768 75.2683C274.805 75.3125 274.833 75.3646 274.847 75.4207C276.71 80.307 278.278 85.3001 279.545 90.3734C279.589 90.5492 279.568 90.735 279.486 90.8963L271.822 105.199C271.546 105.7 271.994 106.334 272.39 106.013L281.039 98.9178C281.278 98.7236 281.592 98.8805 281.666 99.239C283.399 106.999 284.998 115.618 286.439 124.633C286.467 124.815 286.428 125.002 286.327 125.156L279.777 133.88C279.448 134.313 279.777 135.037 280.24 134.798L286.917 131.116C287.164 130.982 287.447 131.183 287.5 131.534C288.575 138.809 289.554 146.293 290.42 153.762C290.433 153.863 290.424 153.965 290.393 154.062C290.362 154.159 290.31 154.248 290.241 154.322L278.963 164.614C278.582 164.958 278.828 165.757 279.284 165.637L290.943 162.65C291.182 162.59 291.406 162.814 291.443 163.135C292.638 174.652 293.549 185.938 294.132 196.207C294.145 196.316 294.128 196.426 294.082 196.525C294.035 196.624 293.962 196.708 293.871 196.768L280.494 204.326C280.031 204.588 280.232 205.514 280.725 205.409L293.99 202.563C294.237 202.511 294.468 202.758 294.483 203.094C294.737 209.002 294.871 214.476 294.871 219.331C294.871 222.413 294.819 225.373 294.715 228.212C294.717 228.317 294.691 228.421 294.638 228.512C294.585 228.603 294.508 228.677 294.416 228.727L280.434 234.568C279.978 234.754 280.061 235.636 280.531 235.673L293.759 236.846C293.998 236.846 294.177 237.159 294.154 237.48C293.558 245.639 292.096 253.711 289.793 261.56C289.71 261.829 289.479 261.971 289.27 261.874L281.151 258.371C280.733 258.192 280.404 258.864 280.71 259.297L286.984 268.215C287.048 268.317 287.085 268.432 287.094 268.552C287.103 268.672 287.084 268.792 287.037 268.902C281.644 280.77 273.921 285.909 265.377 285.909C256.967 285.909 249.378 280.972 244.001 269.589C243.952 269.478 243.932 269.356 243.941 269.235C243.95 269.114 243.989 268.997 244.053 268.895L250.775 259.297C251.074 258.864 250.775 258.192 250.334 258.371L241.521 262.158C241.312 262.247 241.088 262.113 240.998 261.844C238.93 255.271 237.406 247.22 236.577 237.533C236.549 237.396 236.575 237.255 236.649 237.137C236.722 237.019 236.838 236.933 236.973 236.898L250.992 235.651C251.462 235.613 251.537 234.732 251.089 234.545L236.472 228.436C236.396 228.398 236.331 228.342 236.281 228.273C236.232 228.204 236.2 228.124 236.188 228.04L236.017 227.054C236.013 227.012 236.013 226.969 236.017 226.927C235.942 224.492 235.897 221.975 235.897 219.361C235.845 214.424 236.017 208.897 236.248 202.929Z",
    fill: "url(#paint2_linear_575_71672)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M264.189 243.239L265.093 191.92L249.319 178.85L265.213 185.31L265.504 168.535L265.638 168.804L265.541 166.347L265.967 142.237L252.904 130.175L265.713 137.861L265.997 140.415L266.52 110.539L266.811 116.425L268.193 161.081L268.79 159.894L279.038 153.232L268.275 163.695L270.023 220.317L286.208 215.231L270.209 226.225L271.412 265.115L277.499 263.898L271.599 271.27L272.256 292.474L273.062 336.846H262.546L264.107 247.885L251.373 244.942L264.189 243.239Z",
    fill: "#1D1D1D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M296.791 243.978C296.791 243.747 296.963 243.575 297.135 243.612L306.882 245.704C307.225 245.771 307.367 245.136 307.046 244.957L297.262 239.407C297.2 239.364 297.151 239.306 297.12 239.237C297.088 239.169 297.075 239.094 297.082 239.019C297.493 231.939 298.121 224.171 298.95 216.246C298.95 216.022 299.129 215.873 299.293 215.918L307.92 218.158C308.233 218.233 308.405 217.688 308.144 217.412L299.786 209.875C299.735 209.827 299.697 209.767 299.675 209.701C299.653 209.635 299.647 209.564 299.659 209.495C300.107 205.671 300.593 201.839 301.153 198.075L301.833 194.303C301.87 194.071 302.064 193.937 302.228 194.034L307.248 196.797C307.546 196.962 307.8 196.461 307.569 196.155L302.572 189.5C302.503 189.394 302.474 189.267 302.49 189.142C303.491 182.935 304.596 177.042 305.791 171.732C305.843 171.485 306.06 171.373 306.224 171.515L312.692 176.818C312.969 177.042 313.275 176.602 313.088 176.251L307.397 165.637C307.351 165.52 307.351 165.389 307.397 165.271C308.262 161.888 309.332 158.561 310.601 155.308C310.61 155.269 310.628 155.233 310.653 155.203C310.678 155.172 310.71 155.148 310.746 155.131C310.782 155.115 310.821 155.107 310.861 155.107C310.9 155.108 310.939 155.118 310.975 155.136L315.456 157.765C315.687 157.9 315.934 157.616 315.859 157.295L314.388 151.618C314.388 151.514 314.261 151.103 314.149 150.737L313.783 149.28C314.828 147.996 315.897 147.294 316.98 147.294C318.063 147.294 319.287 148.085 320.393 149.534L318.72 157.272C318.645 157.593 318.892 157.877 319.123 157.743L323.156 155.375C323.298 155.293 323.463 155.375 323.537 155.554C324.841 158.95 325.936 162.422 326.816 165.951C326.845 166.071 326.832 166.198 326.779 166.31L321.461 176.266C321.274 176.617 321.58 177.057 321.857 176.833L327.832 171.911C327.996 171.777 328.213 171.911 328.265 172.135C329.468 177.513 330.573 183.488 331.574 189.762C331.596 189.889 331.57 190.02 331.499 190.128L326.958 196.17C326.726 196.476 326.958 196.977 327.279 196.812L331.91 194.258C332.082 194.168 332.276 194.303 332.313 194.549C333.06 199.598 333.732 204.782 334.337 209.965C334.348 210.034 334.342 210.105 334.32 210.171C334.298 210.237 334.26 210.297 334.21 210.346L326.39 217.412C326.129 217.658 326.301 218.203 326.614 218.158L334.696 216.082C334.86 216.082 335.024 216.194 335.047 216.418C335.876 224.41 336.503 232.23 336.906 239.355C336.916 239.43 336.904 239.506 336.873 239.575C336.841 239.644 336.791 239.702 336.727 239.744L327.451 244.972C327.13 245.158 327.272 245.793 327.615 245.719L336.847 243.732C337.019 243.695 337.175 243.866 337.19 244.098C337.37 248.198 337.459 251.985 337.459 255.354C337.459 257.497 337.422 259.544 337.347 261.515C337.35 261.588 337.332 261.66 337.297 261.723C337.261 261.786 337.209 261.838 337.146 261.874L327.436 265.922C327.13 266.056 327.182 266.669 327.511 266.669L336.682 267.483C336.774 267.509 336.853 267.569 336.903 267.651C336.953 267.732 336.97 267.83 336.951 267.924C336.55 273.578 335.549 279.174 333.964 284.617C333.957 284.657 333.942 284.695 333.919 284.729C333.896 284.763 333.867 284.791 333.832 284.812C333.797 284.833 333.758 284.847 333.718 284.852C333.678 284.857 333.637 284.853 333.598 284.841L327.966 282.406C327.675 282.279 327.451 282.749 327.66 283.048L332.014 289.232C332.059 289.303 332.086 289.383 332.092 289.467C332.099 289.55 332.085 289.634 332.052 289.71C328.317 297.926 322.955 301.504 317.002 301.504C311.169 301.504 305.911 298.076 302.184 290.188C302.143 290.114 302.122 290.03 302.122 289.946C302.122 289.861 302.143 289.777 302.184 289.703L306.874 283.048C307.083 282.749 306.874 282.301 306.568 282.406L300.443 285.05C300.406 285.062 300.366 285.066 300.326 285.062C300.287 285.057 300.249 285.044 300.215 285.024C300.18 285.003 300.151 284.975 300.129 284.943C300.107 284.91 300.092 284.872 300.085 284.833C298.451 279.34 297.421 273.685 297.015 267.968C296.997 267.874 297.015 267.775 297.066 267.694C297.118 267.612 297.198 267.553 297.292 267.528L307.001 266.669C307.33 266.669 307.382 266.034 307.068 265.922L296.933 261.687C296.88 261.661 296.835 261.621 296.801 261.573C296.768 261.525 296.746 261.469 296.739 261.411L296.589 260.664C296.586 260.634 296.586 260.604 296.589 260.574C296.535 258.886 296.507 257.144 296.507 255.346C296.515 251.955 296.612 248.124 296.791 243.978Z",
    fill: "url(#paint3_linear_575_71672)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M316.172 271.934L316.792 236.353L305.858 227.285L316.875 231.767L317.084 220.13L317.173 220.324L317.106 218.622L317.397 201.899L308.345 193.534L317.226 198.866L317.42 200.637L317.786 179.918L317.987 183.996L318.943 214.962L319.354 214.14L326.465 209.524L319.003 216.777L320.213 256.041L331.439 252.515L320.34 260.141L321.177 287.111L325.397 286.267L321.311 291.376L321.767 306.075L322.327 336.846H315.03L316.113 275.154L307.277 273.122L316.172 271.934Z",
    fill: "#1D1D1D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M316.172 271.934L316.792 236.353L305.858 227.285L316.875 231.767L317.084 220.13L317.173 220.324L317.106 218.622L317.397 201.899L308.345 193.534L317.226 198.866L317.42 200.637L317.786 179.918L317.987 183.996L318.943 214.962L319.354 214.14L326.465 209.524L319.003 216.777L320.213 256.041L331.439 252.515L320.34 260.141L321.177 287.111L325.397 286.267L321.311 291.376L321.767 306.075L322.327 336.846H315.03L316.113 275.154L307.277 273.122L316.172 271.934Z",
    fill: "#424242"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M318 51.023C323.481 45.5424 323.481 36.6565 318 31.1759C312.52 25.6953 303.634 25.6953 298.153 31.1759C292.672 36.6565 292.672 45.5424 298.153 51.023C303.634 56.5036 312.52 56.5036 318 51.023Z",
    fill: "url(#paint4_linear_575_71672)",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M308.091 68.7361V70.8946",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M308.091 59.5643V66.3311",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M308.091 10.2996V21.6374",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M279.978 40.6008H277.797",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M289.127 40.6008H282.219",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M329.833 40.6008H327.055",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M338.392 40.6008H331.596",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M291.675 24.1768L286.67 19.1726",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M294.684 27.1942L292.877 25.3793",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M329.52 62.0216L321.498 54.0075",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M294.685 54.0075L286.67 62.0216",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M324.613 24.0797L321.498 27.1942",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M329.519 19.1726L325.732 22.9593",
    stroke: "#DBC958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M134.223 62.6191L138.062 75.3386",
    stroke: "url(#paint5_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M124.663 30.8913L133.073 58.7876",
    stroke: "url(#paint6_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5566 23.1909L97.872 60.7294",
    stroke: "url(#paint7_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4727 16.2747L85.6677 20.2332",
    stroke: "url(#paint8_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M106.678 86.1909L117.358 121.623",
    stroke: "url(#paint9_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M103.959 77.1685L105.587 82.5759",
    stroke: "url(#paint10_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9639 57.4431L67.4211 65.5992",
    stroke: "url(#paint11_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M54.022 21.1444L63.9556 54.0971",
    stroke: "url(#paint12_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8877 66.2042L58.2869 110.659",
    stroke: "url(#paint13_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15.916 56.9651L18.7019 66.2042",
    stroke: "url(#paint14_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31006 21.7568L14.93 53.6938",
    stroke: "url(#paint15_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7847 93.0025L24.1838 137.457",
    stroke: "url(#paint16_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5605 159.125L84.4726 165.466",
    stroke: "url(#paint17_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0737 121.011L81.3808 155.203",
    stroke: "url(#paint18_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M161.514 133.088L162.097 135.03",
    stroke: "url(#paint19_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M153.284 105.789L160.663 130.28",
    stroke: "url(#paint20_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M166.07 36.366L179.469 80.8207",
    stroke: "url(#paint21_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4976 195.154L26.0137 200.181",
    stroke: "url(#paint22_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4214 188.268L23.5567 192.025",
    stroke: "url(#paint23_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6147 155.726L21.6745 185.796",
    stroke: "url(#paint24_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M19.187 258.849L21.1364 265.339",
    stroke: "url(#paint25_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74512 220.885L18.3136 255.966",
    stroke: "url(#paint26_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M111.958 270.403L119.793 296.395",
    stroke: "url(#paint27_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M106.394 251.94L111.092 267.513",
    stroke: "url(#paint28_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0786 319.929L24.7965 325.621",
    stroke: "url(#paint29_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M11.397 281.173L22.2343 317.136",
    stroke: "url(#paint30_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6743 173.995L71.0735 218.45",
    stroke: "url(#paint31_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 209.248L118.463 212.445",
    stroke: "url(#paint32_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M107.611 176.43L116.589 206.216",
    stroke: "url(#paint33_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M102.996 224.567L101.935 226.15",
    stroke: "url(#paint34_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7681 225.359L100.351 226.942",
    stroke: "url(#paint35_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4484 186.505L36.6567 189.149",
    stroke: "url(#paint36_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3351 190.74L31.3691 188.888",
    stroke: "url(#paint37_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5472 166.952L48.0244 169.857",
    stroke: "url(#paint38_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9638 170.649L44.3198 169.857",
    stroke: "url(#paint39_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M132.333 281.39L131.542 283.242",
    stroke: "url(#paint40_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M129.689 282.973L127.837 281.39",
    stroke: "url(#paint41_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3465 282.712L48.5474 284.034",
    stroke: "url(#paint42_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9109 283.765L44.5889 281.92",
    stroke: "url(#paint43_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4802 310.989L92.1582 312.573",
    stroke: "url(#paint44_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0446 312.841L88.7227 310.989",
    stroke: "url(#paint45_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M354.772 336.846H1.49365",
    stroke: "url(#paint46_linear_575_71672)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M343.128 314.036C342.266 314.264 341.375 314.362 340.484 314.328C340.484 314.328 340.887 313.103 340.925 313.028C341.335 312.169 342.635 310.75 343.696 310.892C343.87 310.921 344.037 310.987 344.184 311.084C344.332 311.182 344.457 311.31 344.552 311.459C344.648 311.608 344.71 311.776 344.736 311.951C344.762 312.126 344.751 312.305 344.704 312.476C344.571 312.835 344.361 313.161 344.089 313.43C343.816 313.7 343.488 313.907 343.128 314.036Z",
    fill: "#59D9C6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M342.478 319.466C341.596 319.458 340.72 319.32 339.879 319.056C339.605 320.014 339.265 320.952 338.863 321.864C338.639 322.394 338.385 322.924 338.116 323.455C338.266 323.231 338.408 323.029 338.43 323.007C339.05 322.26 340.671 321.259 341.664 321.677C341.826 321.75 341.97 321.856 342.088 321.989C342.206 322.122 342.294 322.278 342.347 322.447C342.4 322.617 342.417 322.796 342.395 322.972C342.374 323.148 342.316 323.318 342.224 323.47C341.999 323.78 341.71 324.038 341.376 324.226C341.042 324.414 340.672 324.528 340.29 324.56C339.431 324.56 338.577 324.429 337.758 324.172C337.661 324.373 337.564 324.575 337.459 324.777C336.981 325.74 336.488 326.704 336.04 327.66C335.883 327.996 335.741 328.332 335.592 328.668C335.726 328.466 335.846 328.302 335.868 328.28C336.488 327.533 338.109 326.532 339.102 326.95C339.263 327.024 339.407 327.131 339.524 327.264C339.641 327.396 339.729 327.552 339.782 327.722C339.835 327.891 339.851 328.069 339.831 328.245C339.81 328.421 339.753 328.59 339.662 328.743C339.44 329.055 339.151 329.315 338.817 329.504C338.482 329.692 338.111 329.805 337.728 329.833C336.892 329.843 336.06 329.719 335.263 329.467C335.129 329.818 334.987 330.169 334.867 330.513C334.748 330.856 334.703 330.976 334.643 331.215C334.583 331.454 334.509 331.693 334.449 331.962C334.337 332.417 334.217 332.888 334.128 333.336C334.053 333.65 333.993 333.949 333.934 334.247C334.091 333.904 334.404 333.254 334.434 333.202C334.942 332.395 336.398 331.133 337.422 331.394C337.592 331.444 337.75 331.529 337.886 331.643C338.021 331.758 338.131 331.9 338.209 332.059C338.286 332.219 338.329 332.393 338.335 332.571C338.341 332.748 338.31 332.925 338.243 333.09C338.067 333.43 337.82 333.728 337.519 333.964C337.217 334.2 336.868 334.368 336.495 334.456C335.629 334.591 334.748 334.591 333.881 334.456C333.777 334.949 333.687 335.435 333.605 335.89C333.545 336.227 333.493 336.555 333.441 336.869H332.776C332.843 336.518 332.91 336.122 332.985 335.778C333.082 335.271 333.202 334.733 333.321 334.188C332.824 333.985 332.338 333.755 331.865 333.5C331.22 334.052 330.504 334.515 329.736 334.875C329.93 335.338 330.117 335.793 330.304 336.219C330.401 336.443 330.498 336.652 330.588 336.869H329.886C329.833 336.734 329.773 336.607 329.721 336.466C329.527 335.995 329.325 335.48 329.124 334.972C328.271 335.174 327.392 335.245 326.517 335.181C326.138 335.122 325.776 334.98 325.457 334.766C325.138 334.551 324.871 334.27 324.672 333.941C324.593 333.782 324.548 333.608 324.541 333.431C324.533 333.254 324.564 333.077 324.629 332.912C324.695 332.747 324.794 332.598 324.921 332.474C325.048 332.35 325.2 332.255 325.367 332.193C326.383 331.857 327.921 333.007 328.489 333.769C328.489 333.814 328.832 334.352 329.019 334.688C328.937 334.471 328.855 334.262 328.78 334.038C328.616 333.597 328.466 333.157 328.31 332.679C328.235 332.447 328.168 332.208 328.093 331.969C328.018 331.73 327.966 331.484 327.906 331.222C327.764 330.647 327.66 330.057 327.555 329.452C326.765 329.768 325.932 329.962 325.083 330.027C324.699 330.025 324.32 329.939 323.972 329.777C323.624 329.614 323.315 329.379 323.066 329.086C322.965 328.94 322.895 328.775 322.861 328.6C322.827 328.426 322.831 328.246 322.871 328.073C322.911 327.9 322.987 327.737 323.094 327.595C323.201 327.453 323.337 327.335 323.492 327.249C324.441 326.763 326.144 327.667 326.816 328.339C326.861 328.377 327.294 328.915 327.525 329.213C327.466 328.855 327.406 328.466 327.361 328.13C327.227 327.07 327.13 325.994 327.025 324.919C327.025 324.59 326.958 324.269 326.92 323.94C326.105 324.269 325.243 324.471 324.366 324.538C323.981 324.539 323.601 324.456 323.252 324.293C322.904 324.131 322.595 323.893 322.349 323.597C322.247 323.452 322.176 323.287 322.141 323.113C322.107 322.938 322.11 322.759 322.15 322.586C322.191 322.413 322.267 322.25 322.375 322.109C322.483 321.968 322.619 321.851 322.775 321.767C323.724 321.274 325.427 322.178 326.099 322.85C326.151 322.902 326.771 323.671 326.92 323.88C326.838 323.134 326.756 322.439 326.652 321.737C326.502 320.784 326.295 319.841 326.032 318.914C325.208 319.247 324.34 319.453 323.455 319.526C323.071 319.524 322.692 319.438 322.345 319.274C321.998 319.11 321.691 318.872 321.446 318.578C321.333 318.428 321.256 318.256 321.218 318.073C321.18 317.89 321.184 317.701 321.228 317.519C321.272 317.338 321.356 317.169 321.474 317.023C321.592 316.878 321.74 316.761 321.909 316.68C322.857 316.195 324.56 317.091 325.232 317.763C325.285 317.823 325.979 318.652 326.061 318.809L326.017 318.645C325.724 317.725 325.352 316.833 324.904 315.978C324.657 315.508 324.396 315.067 324.157 314.641C323.39 315.048 322.567 315.338 321.715 315.5C321.33 315.537 320.943 315.489 320.579 315.36C320.215 315.231 319.884 315.024 319.608 314.754C319.492 314.62 319.406 314.463 319.354 314.294C319.302 314.124 319.286 313.946 319.307 313.77C319.328 313.594 319.386 313.425 319.476 313.273C319.567 313.12 319.688 312.989 319.832 312.886C320.721 312.296 322.514 313.006 323.253 313.633C323.298 313.633 323.671 314.036 323.94 314.313C323.821 314.126 323.701 313.924 323.582 313.745C323.134 313.073 322.686 312.49 322.282 311.968C322.051 311.676 321.834 311.415 321.632 311.176C320.77 311.186 319.911 311.062 319.086 310.81C318.729 310.671 318.406 310.456 318.14 310.18C317.875 309.904 317.672 309.574 317.547 309.212C317.504 309.039 317.499 308.859 317.53 308.684C317.562 308.509 317.63 308.342 317.73 308.195C317.83 308.048 317.96 307.923 318.111 307.83C318.262 307.736 318.431 307.675 318.608 307.651C319.668 307.539 320.93 308.995 321.311 309.891C321.349 309.966 321.737 311.206 321.715 311.206C321.916 311.437 322.133 311.684 322.357 311.953C322.775 312.468 323.238 313.043 323.701 313.708C324.206 314.428 324.67 315.176 325.091 315.949C325.569 316.803 325.967 317.701 326.278 318.63C326.278 318.316 326.278 317.442 326.278 317.375C326.398 316.434 327.189 314.679 328.242 314.485C328.42 314.451 328.603 314.457 328.779 314.5C328.955 314.544 329.119 314.625 329.261 314.737C329.402 314.85 329.518 314.992 329.6 315.153C329.682 315.314 329.729 315.491 329.736 315.672C329.719 316.056 329.62 316.431 329.445 316.773C329.269 317.114 329.022 317.414 328.72 317.651C327.982 318.13 327.176 318.498 326.33 318.742C326.629 319.691 326.864 320.659 327.032 321.64C327.137 322.215 327.219 322.79 327.294 323.373C327.294 323.104 327.294 322.857 327.294 322.827C327.421 321.879 328.213 320.124 329.258 319.929C329.433 319.903 329.612 319.914 329.782 319.961C329.953 320.007 330.112 320.089 330.249 320.201C330.386 320.313 330.498 320.452 330.579 320.61C330.659 320.768 330.705 320.94 330.715 321.117C330.701 321.501 330.603 321.878 330.427 322.22C330.252 322.562 330.003 322.861 329.699 323.096C328.987 323.571 328.206 323.931 327.383 324.164C327.383 324.388 327.436 324.612 327.466 324.837C327.593 325.905 327.72 326.98 327.869 328.026C327.921 328.392 327.988 328.773 328.056 329.116C328.056 328.877 328.056 328.668 328.056 328.638C328.175 327.697 328.967 325.942 330.02 325.748C330.195 325.72 330.374 325.73 330.545 325.776C330.716 325.823 330.876 325.904 331.013 326.016C331.151 326.128 331.263 326.268 331.343 326.426C331.423 326.585 331.468 326.758 331.476 326.935C331.46 327.319 331.36 327.694 331.185 328.036C331.01 328.377 330.762 328.677 330.461 328.915C329.772 329.376 329.016 329.729 328.22 329.96C328.302 330.326 328.377 330.707 328.466 331.051C328.534 331.29 328.586 331.529 328.668 331.76L328.892 332.462C329.056 332.903 329.213 333.358 329.385 333.784C329.497 334.083 329.609 334.367 329.729 334.651C329.669 334.285 329.572 333.56 329.572 333.5C329.583 332.663 329.809 331.842 330.229 331.118C330.218 331.024 330.218 330.928 330.229 330.834C330.252 330.658 330.311 330.489 330.403 330.338C330.495 330.186 330.618 330.056 330.764 329.955C330.91 329.854 331.075 329.785 331.249 329.753C331.424 329.72 331.603 329.725 331.775 329.766C332.806 330.042 333.463 331.85 333.508 332.806C333.508 332.858 333.508 333.471 333.448 333.859C333.5 333.635 333.545 333.418 333.605 333.187C333.71 332.731 333.829 332.276 333.964 331.79C334.031 331.559 334.098 331.319 334.173 331.08C334.247 330.841 334.337 330.602 334.427 330.334C334.628 329.773 334.86 329.221 335.106 328.668C334.274 328.491 333.473 328.188 332.731 327.772C332.411 327.56 332.141 327.28 331.941 326.952C331.741 326.624 331.616 326.256 331.574 325.875C331.569 325.698 331.601 325.522 331.669 325.359C331.736 325.195 331.838 325.048 331.966 324.926C332.094 324.804 332.246 324.711 332.413 324.652C332.579 324.592 332.757 324.569 332.933 324.583C333.993 324.702 334.92 326.39 335.106 327.324C335.106 327.383 335.181 328.071 335.211 328.444C335.36 328.115 335.51 327.779 335.681 327.451C336.152 326.495 336.66 325.539 337.175 324.59C337.332 324.299 337.481 324.007 337.631 323.716C336.769 323.535 335.938 323.228 335.166 322.805C334.846 322.593 334.576 322.313 334.376 321.985C334.176 321.657 334.051 321.29 334.008 320.908C334.01 320.737 334.047 320.567 334.116 320.411C334.186 320.254 334.286 320.113 334.412 319.997C334.538 319.881 334.687 319.792 334.849 319.735C335.01 319.679 335.182 319.656 335.353 319.668C336.413 319.78 337.339 321.468 337.526 322.402C337.526 322.476 337.631 323.462 337.646 323.709C337.974 323.066 338.303 322.424 338.602 321.774C339.006 320.901 339.356 320.003 339.647 319.085C338.777 318.905 337.939 318.595 337.16 318.167C336.842 317.954 336.574 317.675 336.375 317.349C336.175 317.023 336.048 316.657 336.003 316.277C335.998 316.099 336.031 315.923 336.098 315.758C336.166 315.594 336.268 315.446 336.397 315.323C336.526 315.201 336.679 315.107 336.846 315.047C337.014 314.988 337.192 314.964 337.369 314.978C338.43 315.097 339.349 316.785 339.543 317.719C339.543 317.793 339.655 318.854 339.655 319.048C339.671 318.995 339.691 318.942 339.715 318.891C339.975 317.96 340.155 317.008 340.252 316.046C340.312 315.515 340.342 315.007 340.357 314.507C339.493 314.431 338.646 314.219 337.847 313.88C337.506 313.704 337.208 313.456 336.973 313.153C336.738 312.85 336.572 312.499 336.488 312.124C336.464 311.949 336.477 311.771 336.526 311.601C336.575 311.431 336.66 311.273 336.774 311.138C336.888 311.003 337.029 310.893 337.188 310.816C337.347 310.739 337.521 310.696 337.698 310.69C338.766 310.69 339.871 312.266 340.163 313.17C340.163 313.222 340.29 313.738 340.357 314.119C340.357 313.895 340.357 313.663 340.357 313.446C340.357 312.64 340.305 311.9 340.252 311.251C340.252 310.877 340.185 310.541 340.148 310.227C339.421 309.76 338.771 309.183 338.221 308.517C338.001 308.204 337.852 307.847 337.783 307.47C337.715 307.093 337.729 306.707 337.825 306.336C337.882 306.167 337.974 306.011 338.095 305.88C338.216 305.748 338.364 305.644 338.528 305.573C338.692 305.503 338.87 305.468 339.048 305.47C339.227 305.473 339.403 305.514 339.565 305.589C340.514 306.082 340.76 307.987 340.603 308.928C340.603 309.01 340.237 310.257 340.215 310.242C340.26 310.541 340.297 310.862 340.335 311.221C340.402 311.871 340.469 312.61 340.484 313.424C340.515 314.296 340.495 315.169 340.424 316.038C340.349 317.014 340.187 317.982 339.939 318.929C339.939 318.929 339.939 318.929 339.939 318.966C340.103 318.697 340.596 317.98 340.641 317.928C341.268 317.181 342.881 316.18 343.875 316.598C344.037 316.671 344.181 316.777 344.299 316.91C344.417 317.043 344.505 317.199 344.558 317.369C344.611 317.538 344.627 317.717 344.606 317.893C344.585 318.069 344.527 318.239 344.435 318.391C344.207 318.702 343.913 318.959 343.575 319.145C343.237 319.33 342.863 319.44 342.478 319.466Z",
    fill: "#59D9C6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M324.15 314.44C324.15 314.44 323.814 313.2 323.799 313.118C323.672 312.169 323.97 310.272 324.934 309.809C325.095 309.736 325.269 309.698 325.445 309.696C325.622 309.695 325.797 309.731 325.959 309.801C326.121 309.871 326.266 309.975 326.385 310.105C326.505 310.235 326.595 310.389 326.652 310.556C326.736 310.93 326.739 311.317 326.66 311.692C326.582 312.067 326.423 312.421 326.196 312.729C325.603 313.398 324.913 313.975 324.15 314.44Z",
    fill: "#59D9C6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M194.311 308.099C193.225 308.388 192.102 308.514 190.979 308.472C190.979 308.472 191.487 306.926 191.532 306.829C192.055 305.746 193.691 303.954 195.028 304.14C195.248 304.176 195.459 304.258 195.645 304.381C195.832 304.504 195.991 304.664 196.111 304.852C196.232 305.04 196.311 305.252 196.345 305.473C196.378 305.694 196.364 305.919 196.305 306.134C196.134 306.586 195.867 306.996 195.523 307.335C195.179 307.674 194.765 307.935 194.311 308.099Z",
    fill: "#59D9C6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M193.496 314.94C192.384 314.935 191.279 314.763 190.218 314.432C189.873 315.638 189.446 316.818 188.94 317.965C188.649 318.637 188.335 319.302 188.014 319.967C188.208 319.69 188.38 319.437 188.41 319.407C189.194 318.495 191.248 317.203 192.488 317.726C192.689 317.819 192.868 317.953 193.014 318.119C193.16 318.284 193.27 318.479 193.337 318.69C193.404 318.901 193.426 319.123 193.402 319.343C193.378 319.563 193.308 319.775 193.198 319.967C192.915 320.36 192.55 320.687 192.128 320.924C191.707 321.161 191.238 321.304 190.755 321.341C189.674 321.345 188.598 321.181 187.566 320.856L187.193 321.603C186.58 322.812 185.968 324.022 185.4 325.232C185.198 325.658 185.019 326.084 184.84 326.51C185.004 326.256 185.154 326.046 185.176 326.017C185.968 325.113 188.022 323.813 189.254 324.344C189.455 324.436 189.634 324.57 189.78 324.736C189.926 324.902 190.036 325.097 190.103 325.307C190.17 325.518 190.192 325.741 190.168 325.961C190.144 326.18 190.074 326.393 189.964 326.584C189.68 326.976 189.314 327.302 188.893 327.539C188.471 327.776 188.003 327.919 187.521 327.959C186.47 327.96 185.425 327.801 184.422 327.488C184.25 327.929 184.071 328.369 183.921 328.81C183.832 329.109 183.72 329.393 183.637 329.699L183.391 330.588C183.249 331.163 183.107 331.76 182.988 332.32C182.898 332.716 182.823 333.067 182.749 333.463C182.943 333.045 183.339 332.216 183.376 332.149C184.018 331.133 185.848 329.542 187.155 329.908C187.376 329.966 187.581 330.071 187.758 330.215C187.935 330.36 188.078 330.54 188.179 330.745C188.279 330.95 188.335 331.174 188.341 331.402C188.347 331.63 188.305 331.856 188.216 332.066C187.993 332.501 187.676 332.882 187.289 333.18C186.901 333.478 186.453 333.687 185.975 333.792C184.881 333.961 183.768 333.961 182.674 333.792C182.554 334.419 182.435 335.024 182.338 335.599C182.263 336.025 182.196 336.436 182.129 336.832H181.292C181.374 336.391 181.457 335.935 181.554 335.457C181.673 334.822 181.823 334.143 181.979 333.448C181.349 333.201 180.736 332.914 180.142 332.589C179.328 333.28 178.427 333.86 177.461 334.315C177.7 334.905 177.939 335.48 178.17 336.017C178.297 336.294 178.417 336.563 178.529 336.832H177.647C177.58 336.66 177.506 336.495 177.438 336.324C177.192 335.726 176.938 335.084 176.691 334.419C175.615 334.669 174.507 334.754 173.405 334.673C172.927 334.596 172.472 334.417 172.069 334.147C171.667 333.878 171.328 333.525 171.075 333.112C170.976 332.912 170.921 332.693 170.913 332.47C170.904 332.247 170.943 332.025 171.026 331.818C171.109 331.611 171.235 331.423 171.395 331.268C171.555 331.113 171.747 330.993 171.956 330.916C173.233 330.483 175.183 331.932 175.892 332.903C175.937 332.955 176.325 333.65 176.557 334.053C176.46 333.784 176.355 333.515 176.258 333.239C176.049 332.686 175.862 332.126 175.661 331.521C175.571 331.23 175.489 330.931 175.392 330.632C175.295 330.334 175.235 330.012 175.153 329.699C174.981 328.952 174.839 328.205 174.72 327.458C173.723 327.865 172.67 328.117 171.598 328.205C171.114 328.201 170.637 328.093 170.199 327.888C169.76 327.683 169.371 327.386 169.058 327.017C168.93 326.834 168.841 326.625 168.799 326.405C168.756 326.185 168.76 325.958 168.811 325.74C168.862 325.522 168.958 325.316 169.093 325.138C169.228 324.959 169.4 324.81 169.596 324.702C170.791 324.09 172.935 325.225 173.786 326.076C173.838 326.129 174.384 326.823 174.675 327.182C174.6 326.726 174.525 326.271 174.473 325.807C174.301 324.478 174.182 323.119 174.047 321.767C174.047 321.356 173.965 320.945 173.92 320.527C172.888 320.936 171.801 321.187 170.694 321.274C170.21 321.271 169.732 321.163 169.294 320.958C168.856 320.753 168.467 320.456 168.154 320.086C168.025 319.904 167.936 319.695 167.893 319.476C167.849 319.256 167.853 319.03 167.904 318.811C167.955 318.593 168.052 318.388 168.187 318.21C168.323 318.032 168.495 317.885 168.692 317.778C169.887 317.159 172.031 318.294 172.882 319.145C172.942 319.205 173.726 320.183 173.913 320.437C173.816 319.534 173.711 318.622 173.569 317.741C173.401 316.541 173.152 315.353 172.823 314.186C171.786 314.596 170.693 314.848 169.581 314.933C169.097 314.932 168.618 314.826 168.18 314.621C167.741 314.415 167.352 314.117 167.042 313.745C166.913 313.562 166.825 313.354 166.782 313.135C166.74 312.915 166.744 312.689 166.795 312.471C166.846 312.253 166.942 312.049 167.077 311.871C167.212 311.693 167.383 311.545 167.579 311.437C168.774 310.817 170.918 311.96 171.769 312.804C171.837 312.871 172.673 313.917 172.815 314.119C172.794 314.052 172.777 313.985 172.763 313.917C172.392 312.755 171.919 311.628 171.351 310.549C171.045 309.951 170.716 309.398 170.388 308.868C169.421 309.386 168.381 309.753 167.303 309.959C166.822 310.011 166.335 309.957 165.877 309.801C165.419 309.645 165.001 309.39 164.652 309.055C164.504 308.887 164.393 308.69 164.326 308.477C164.259 308.264 164.238 308.039 164.265 307.817C164.291 307.595 164.363 307.381 164.477 307.189C164.592 306.997 164.745 306.831 164.928 306.702C166.048 305.955 168.304 306.859 169.245 307.606C169.297 307.643 169.768 308.114 170.111 308.465C169.954 308.226 169.805 307.979 169.656 307.755C169.088 306.904 168.52 306.164 168.013 305.515C167.721 305.149 167.452 304.82 167.198 304.521C166.111 304.531 165.028 304.375 163.987 304.058C163.537 303.883 163.13 303.612 162.796 303.264C162.462 302.916 162.208 302.498 162.052 302.042C161.998 301.824 161.99 301.598 162.029 301.378C162.067 301.157 162.152 300.947 162.278 300.762C162.403 300.577 162.566 300.42 162.757 300.302C162.947 300.184 163.16 300.107 163.382 300.077C164.719 299.935 166.31 301.765 166.795 302.863C166.84 302.96 167.333 304.521 167.303 304.521C167.557 304.805 167.826 305.119 168.117 305.462C168.64 306.105 169.223 306.837 169.805 307.703C170.443 308.602 171.029 309.537 171.56 310.504C172.157 311.58 172.657 312.707 173.054 313.872C173.054 313.872 173.054 313.872 173.054 313.917C173.054 313.521 173.054 312.423 173.054 312.334C173.211 311.146 174.212 308.935 175.534 308.689C175.754 308.654 175.98 308.666 176.196 308.724C176.411 308.782 176.612 308.885 176.786 309.026C176.959 309.167 177.101 309.343 177.202 309.542C177.302 309.741 177.36 309.959 177.371 310.183C177.351 310.666 177.226 311.139 177.006 311.57C176.785 312 176.474 312.378 176.094 312.677C175.171 313.281 174.164 313.746 173.106 314.059C173.481 315.256 173.775 316.476 173.988 317.711C174.115 318.458 174.227 319.16 174.324 319.892C174.324 319.556 174.324 319.25 174.324 319.205C174.481 318.01 175.474 315.799 176.803 315.56C177.024 315.525 177.25 315.537 177.465 315.595C177.681 315.653 177.882 315.756 178.055 315.897C178.229 316.038 178.37 316.214 178.471 316.413C178.572 316.613 178.63 316.831 178.641 317.054C178.62 317.538 178.495 318.012 178.273 318.443C178.051 318.874 177.738 319.251 177.356 319.549C176.456 320.142 175.471 320.598 174.436 320.9C174.436 321.177 174.503 321.461 174.54 321.737C174.697 323.089 174.854 324.441 175.048 325.755C175.115 326.218 175.198 326.674 175.28 327.129C175.28 326.831 175.28 326.577 175.28 326.532C175.437 325.344 176.437 323.134 177.759 322.887C177.98 322.852 178.206 322.864 178.421 322.922C178.637 322.98 178.838 323.083 179.011 323.224C179.185 323.365 179.326 323.541 179.427 323.74C179.528 323.94 179.586 324.158 179.597 324.381C179.575 324.863 179.45 325.335 179.23 325.764C179.009 326.193 178.699 326.57 178.32 326.868C177.446 327.455 176.486 327.901 175.474 328.19C175.571 328.653 175.676 329.124 175.788 329.564C175.877 329.871 175.937 330.162 176.042 330.461C176.146 330.759 176.228 331.058 176.325 331.349C176.527 331.902 176.729 332.477 176.945 333.015C177.087 333.388 177.229 333.762 177.371 334.098C177.304 333.642 177.177 332.731 177.177 332.656C177.195 331.606 177.48 330.578 178.006 329.669C177.995 329.552 177.995 329.435 178.006 329.318C178.023 329.084 178.09 328.857 178.205 328.652C178.319 328.448 178.477 328.271 178.667 328.134C178.857 327.997 179.075 327.904 179.306 327.86C179.536 327.817 179.773 327.825 180 327.884C181.3 328.235 182.121 330.513 182.181 331.715C182.181 331.783 182.181 332.559 182.106 333.045C182.166 332.761 182.233 332.485 182.301 332.193C182.435 331.618 182.592 331.051 182.749 330.438C182.838 330.139 182.928 329.848 183.025 329.549C183.122 329.251 183.234 328.944 183.339 328.638C183.593 327.936 183.891 327.234 184.198 326.532C183.15 326.316 182.142 325.938 181.21 325.412C180.801 325.147 180.455 324.796 180.197 324.383C179.938 323.97 179.774 323.505 179.716 323.022C179.71 322.798 179.751 322.577 179.837 322.37C179.922 322.164 180.05 321.978 180.212 321.824C180.374 321.671 180.567 321.553 180.777 321.479C180.988 321.405 181.212 321.375 181.434 321.393C182.779 321.535 183.936 323.671 184.183 324.844C184.183 324.919 184.272 325.785 184.31 326.256C184.494 325.837 184.688 325.419 184.892 325.001C185.49 323.798 186.132 322.596 186.774 321.401L187.349 320.295C186.261 320.067 185.211 319.679 184.235 319.145C183.833 318.876 183.495 318.523 183.244 318.111C182.992 317.698 182.833 317.235 182.779 316.755C182.781 316.538 182.828 316.324 182.916 316.126C183.004 315.928 183.132 315.75 183.292 315.603C183.451 315.457 183.639 315.344 183.843 315.272C184.048 315.201 184.265 315.171 184.481 315.187C185.818 315.329 186.984 317.427 187.223 318.637C187.223 318.727 187.357 319.967 187.364 320.288C187.79 319.474 188.201 318.667 188.574 317.846C189.084 316.744 189.523 315.612 189.889 314.455C188.795 314.227 187.741 313.839 186.759 313.305C186.359 313.035 186.021 312.682 185.769 312.269C185.518 311.857 185.359 311.394 185.303 310.915C185.296 310.691 185.336 310.468 185.421 310.261C185.506 310.054 185.634 309.867 185.796 309.712C185.958 309.558 186.151 309.44 186.362 309.365C186.573 309.29 186.798 309.261 187.021 309.279C188.358 309.428 189.515 311.52 189.762 312.737C189.762 312.827 189.904 314.163 189.904 314.41C189.904 314.343 189.956 314.276 189.971 314.208C190.305 313.036 190.535 311.836 190.658 310.623C190.733 309.959 190.763 309.316 190.785 308.689C189.697 308.585 188.632 308.316 187.626 307.89C187.193 307.665 186.814 307.348 186.517 306.961C186.22 306.574 186.012 306.126 185.908 305.649C185.876 305.425 185.892 305.196 185.956 304.978C186.02 304.761 186.129 304.559 186.277 304.387C186.425 304.216 186.608 304.077 186.813 303.982C187.019 303.886 187.242 303.836 187.469 303.834C188.813 303.834 190.203 305.821 190.576 306.963C190.576 307.023 190.733 307.71 190.823 308.159C190.823 307.875 190.823 307.583 190.823 307.315C190.823 306.291 190.755 305.365 190.688 304.536C190.651 304.066 190.606 303.647 190.554 303.251C189.643 302.661 188.827 301.936 188.134 301.1C187.854 300.706 187.664 300.254 187.577 299.778C187.491 299.302 187.51 298.812 187.633 298.344C187.708 298.134 187.826 297.941 187.98 297.779C188.133 297.617 188.319 297.49 188.526 297.404C188.732 297.319 188.954 297.278 189.178 297.285C189.401 297.291 189.62 297.344 189.822 297.441C191.017 298.061 191.315 300.466 191.136 301.653C191.136 301.758 190.666 303.326 190.651 303.311C190.71 303.692 190.755 304.095 190.808 304.544C190.89 305.373 190.972 306.299 190.994 307.322C191.035 308.423 191.01 309.525 190.92 310.623C190.823 311.851 190.618 313.069 190.307 314.261V314.305C190.524 313.977 191.144 313.066 191.196 312.998C191.988 312.087 194.042 310.795 195.274 311.325C195.475 311.418 195.654 311.552 195.8 311.718C195.946 311.884 196.056 312.078 196.123 312.289C196.19 312.5 196.212 312.722 196.188 312.942C196.164 313.162 196.094 313.375 195.984 313.566C195.696 313.965 195.324 314.295 194.894 314.532C194.464 314.77 193.987 314.909 193.496 314.94Z",
    fill: "#59D9C6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M170.425 308.622C170.425 308.622 169.992 307.053 169.977 306.949C169.812 305.761 170.193 303.363 171.403 302.773C171.607 302.682 171.828 302.634 172.052 302.634C172.276 302.633 172.497 302.68 172.702 302.771C172.906 302.862 173.089 302.995 173.238 303.162C173.388 303.328 173.501 303.524 173.569 303.737C173.68 304.208 173.686 304.698 173.587 305.171C173.487 305.645 173.285 306.091 172.994 306.478C172.248 307.315 171.382 308.038 170.425 308.622Z",
    fill: "#59D9C6"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M126.971 219.368C126.971 219.368 124.603 222.841 122.392 223.79C120.182 224.739 112.451 226.315 111.936 226.315C111.421 226.315 111.189 225.209 111.779 223.79C112.369 222.371 115.73 218.741 116.671 217.949C118.095 216.975 119.571 216.079 121.093 215.268L126.971 219.368Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6997 168.52C51.6997 168.52 54.4259 176.624 61.1255 179.253C67.825 181.882 71.186 182.883 71.186 182.883C71.186 182.883 78.6026 205.155 90.045 215.402C90.045 215.402 89.8732 241.544 100.255 255.734C100.255 255.734 92.1736 275.251 98.8134 290.375C98.8134 290.375 82.6508 289.277 80.1412 294.558C80.1412 294.558 69.4831 285.774 64.0234 281.233C58.5636 276.692 51.3935 260.694 49.0856 255.742C46.7777 250.79 36.8964 220.713 36.3885 213.005C35.8806 205.297 38.2632 192.615 39.2491 189.851C40.235 187.088 45.747 173.913 51.6997 168.52Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6995 168.52C51.6995 168.52 45.7244 174.197 40.3393 190.994C40.3393 190.994 40.1974 227.973 53.126 253.934C53.126 253.934 64.3294 279.814 80.1111 294.543C73.8055 292.104 67.6763 289.232 61.7675 285.946C53.7758 281.278 49.1377 271.12 48.1144 268.768C47.0912 266.415 42.9684 257.983 40.1974 256.422C37.4265 254.861 34.2223 251.283 34.1103 247.295C33.9982 243.306 33.9684 233.066 31.1227 227.233C28.2771 221.4 27.941 217.12 30.2937 209.876C32.6464 202.631 37.7626 190.621 37.7626 190.621C37.7626 190.621 45.1792 173.883 51.6995 168.52Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M73.598 180.142C73.598 180.142 60.4154 193.444 56.1432 199.188C51.871 204.931 46.4337 222.027 45.8735 228.256",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8731 164.935L48.3237 173.472",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5177 214.14C93.5177 214.14 72.8289 223.917 64.6281 228.622C56.4272 233.328 54.6123 235.524 54.6123 235.524",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M103.623 256.743C103.623 256.743 89.4323 255.749 78.6622 255.212C67.8921 254.674 53.9626 248.572 50.6987 245.569",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M101.084 290.472C101.084 290.472 83.7037 285.334 74.3527 278.895C65.0016 272.457 60.4307 267.102 60.4307 267.102",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8315 252.919L54.4331 239.206L63.9335 270.978",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8943 235.718L49.832 211.668",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0059 217.3L53.41 236.883L47.1063 232.013",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4099 236.883L49.4663 241.805",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M127.598 223.058L55.374 236.696",
    stroke: "#C6A924",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M131.796 213.61L135.261 213.237C135.813 213.176 136.371 213.227 136.902 213.387C137.434 213.546 137.928 213.812 138.354 214.166C138.781 214.521 139.132 214.958 139.385 215.452C139.639 215.945 139.791 216.485 139.832 217.038C139.905 218.05 139.604 219.053 138.985 219.857C138.367 220.661 137.475 221.21 136.479 221.4L127.598 223.088",
    stroke: "#1D1D1D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M175.847 121.922C175.847 121.922 170.582 126.344 168.692 130.556C166.802 134.768 166.586 140.654 157.324 141.08C148.063 141.505 135.433 140.236 132.909 149.295C130.384 158.355 142.17 160.028 138.174 165.727C134.178 171.426 126.807 176.669 131.019 183.615C135.232 190.561 146.704 195.296 151.432 192.032C156.159 188.768 172.061 175.825 178.163 168.042C184.265 160.26 178.372 147.832 177.11 139.832C175.847 131.833 176.9 125.731 180.478 122.998C184.056 120.264 178.372 121.295 175.847 121.922Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M154.434 172.016C154.434 172.016 149.064 177.244 146.382 178.327C145.179 178.78 144.149 179.602 143.439 180.675C142.73 181.748 142.377 183.017 142.431 184.302C142.431 186.991 142.596 192.518 141.49 193.937C140.385 195.356 136.12 200.883 134.544 201.197C132.968 201.51 129.809 201.988 128.704 203.564C127.806 204.843 127.054 206.219 126.463 207.665C125.828 209.091 118.725 215.403 119.203 216.037L119.674 216.665C119.674 216.665 123.617 219.824 125.985 220.138C128.015 220.32 130.052 219.88 131.826 218.876C132.931 218.241 138.144 215.246 140.512 214.454C142.88 213.662 146.98 211.929 147.458 210.824C147.936 209.719 151.558 205.932 151.558 205.932C151.558 205.932 155.666 195.513 156.137 188.754C156.607 181.994 154.434 172.016 154.434 172.016Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M143.694 185.594C143.694 185.594 144.485 180.366 144.799 183.227C145.113 186.087 147.167 195.065 147.488 198.695C147.703 200.951 148.345 203.145 149.378 205.163C149.378 205.163 143.537 199.008 143.066 194.9",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M133.185 204.154C131.549 203.751 130.997 203.714 130.437 203.9",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M151.618 205.954C151.618 205.954 144.993 207.373 138.675 205.641L136.128 204.939",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M209.368 163.337C209.368 163.337 219.466 167.124 219.944 168.229C220.422 169.334 221.826 179.91 221.826 179.91L222.461 191.592C222.461 191.592 232.88 251.731 232.88 254.412C232.88 257.094 229.892 258.52 224.828 258.52C219.764 258.52 209.196 252.993 199.569 252.545C189.941 252.097 182.681 252.859 172.105 255.383C161.53 257.908 150.446 261.359 143.53 261.359C139.64 261.44 135.778 260.694 132.199 259.17C132.199 259.17 155.241 228.861 157.138 211.974C159.035 195.087 159.035 182.928 158.714 181.666C158.444 179.519 158.287 177.36 158.243 175.198C158.243 175.198 154.135 175.033 165.817 169.969C177.498 164.905 199.262 163.494 209.368 163.337Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M217.098 179.253L216.941 171.202L210.622 163.807C213.333 164.861 219.585 167.363 219.958 168.229C220.429 169.334 221.848 179.91 221.848 179.91L222.483 191.592C222.483 191.592 232.902 251.731 232.902 254.412C232.902 254.833 232.816 255.25 232.647 255.635C232.479 256.021 232.232 256.367 231.923 256.653C232.162 255.988 231.923 255.159 231.64 254.076C231.162 252.344 222.161 244.763 222.161 244.763L217.098 179.253Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M207.635 214.529L211.847 229.892C211.847 229.892 219.421 243.336 221.945 254.099C224.47 264.861 226.158 268.618 226.576 275.99C226.994 283.362 232.469 321.453 232.469 321.453C232.469 321.453 240.901 324.366 245.532 324.366C250.163 324.366 254.158 322.678 251.843 326.681C249.528 330.685 241.028 332.873 238.713 332.873C237.012 332.952 235.332 333.287 233.731 333.866C233.731 333.866 234.993 335.129 233.522 335.554C232.051 335.98 227.211 336.817 226.576 336.6C225.941 336.383 224.895 331.977 224.261 328.384C223.626 324.792 223.633 321.864 223.207 320.811C222.782 319.758 216.261 298.083 214.992 294.505C213.722 290.928 212.258 282.712 212.258 279.134C212.258 275.557 211.623 269.425 211.623 269.425C211.623 269.425 197.522 251.574 194.788 247.967C192.055 244.359 189.949 241.021 188.686 240.386C187.424 239.751 184.9 241.648 184.9 241.648C184.9 241.648 173.532 262.277 169.962 267.117C166.392 271.957 159.879 282.204 159.879 282.204C159.879 282.204 152.305 292.937 149.146 296.305C145.987 299.674 140.094 305.567 139.041 306.194C137.988 306.822 127.89 321.349 126.836 322.827C125.783 324.306 122.624 333.56 118.419 334.404C114.214 335.248 113.579 328.511 114.416 326.188C115.252 323.866 119.046 318.189 121.788 315.665C124.529 313.14 134.201 295.245 136.942 291.017C139.683 286.79 144.493 275.93 145.964 273.406C147.436 270.881 151.872 260.522 151.872 260.522L167.228 221.206L169.327 214.26L207.635 214.529Z",
    fill: "url(#paint47_linear_575_71672)",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M191.771 216.388C191.771 216.388 192.951 220.997 192.563 221.923C192.221 222.603 191.775 223.226 191.241 223.768L189.53 222.184",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M204.647 220.078C202.91 222.079 200.809 223.731 198.456 224.948",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M199.77 226.441C199.153 226.763 198.502 227.013 197.828 227.188",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M204.939 223.499C204.939 223.499 202.847 224.836 200.823 225.911",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M177.938 222.461C177.228 222.068 176.477 221.755 175.698 221.527",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M185.714 226.793C185.714 226.793 182.39 224.821 179.522 223.282",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M176.266 219.585C176.266 219.585 181.793 221.826 182.592 222.744",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M233.514 335.554C232.021 335.973 227.203 336.817 226.568 336.6C225.933 336.383 224.888 331.977 224.253 328.384C223.618 324.792 223.626 321.864 223.2 320.811C222.894 320.064 219.383 308.45 216.993 300.757C221.184 300.726 225.34 300.002 229.294 298.613C230.84 310.108 232.469 321.453 232.469 321.453C232.469 321.453 240.901 324.366 245.532 324.366C250.162 324.366 254.158 322.678 251.843 326.681C249.528 330.685 241.028 332.873 238.713 332.873C237.012 332.952 235.332 333.287 233.731 333.866C233.731 333.866 234.986 335.129 233.514 335.554Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M230.138 296.268L230.706 300.122C230.729 300.282 230.712 300.446 230.658 300.598C230.603 300.75 230.512 300.887 230.392 300.996C229.563 301.743 227.308 303.393 222.991 304.193C219.51 304.835 217.845 304.768 217.075 304.618C216.9 304.584 216.737 304.501 216.605 304.38C216.473 304.259 216.377 304.103 216.328 303.931L214.917 299.054C214.875 298.913 214.866 298.764 214.889 298.619C214.912 298.473 214.968 298.335 215.052 298.214C215.136 298.093 215.245 297.992 215.373 297.919C215.501 297.846 215.644 297.802 215.791 297.792C218.524 297.583 225.201 296.948 228.779 295.499C228.918 295.442 229.068 295.417 229.219 295.426C229.369 295.436 229.515 295.479 229.646 295.553C229.776 295.627 229.889 295.73 229.974 295.854C230.06 295.978 230.116 296.119 230.138 296.268Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M118.411 334.434C114.199 335.271 113.571 328.541 114.408 326.218C115.244 323.895 119.039 318.219 121.78 315.695C123.513 314.089 128.046 306.299 131.825 299.741C134.544 302.632 138.308 304.013 140.863 304.648C140.293 305.217 139.682 305.741 139.033 306.217C137.987 306.851 127.882 321.371 126.829 322.85C125.776 324.329 122.616 333.59 118.411 334.434Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M134.29 294.916C134.29 294.916 133.543 295.454 135.68 298.023C137.816 300.593 141.147 301.451 141.894 301.347C143.094 301.018 144.276 300.624 145.434 300.167C145.434 300.167 146.181 300.167 145.538 301.235C144.896 302.303 142.185 306.075 140.721 306.919C137.935 308.524 135.792 307.987 132.505 306.702C129.622 305.589 129.182 303.378 129.182 302.632C129.182 301.885 131.542 297.702 132.393 295.91C133.245 294.117 134.074 294.49 134.29 294.916Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M207.418 211.369L207.836 215.783H183.637C178.372 215.783 168.266 215.993 168.266 215.993L169.319 212.206C169.319 212.206 187.633 208.001 194.37 208.001C201.107 208.001 207.418 211.369 207.418 211.369Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M194.579 157.915C196.03 157.592 197.515 157.452 199.001 157.496C201.943 157.496 209.099 158.759 210.152 162.963C211.205 167.168 216.254 176.407 216.254 176.407C215.4 180.11 213.981 183.659 212.049 186.931C209.061 191.562 208.045 193.033 208.045 193.033C208.045 193.033 211.84 207.762 210.152 210.294C208.464 212.826 207 213.446 205.73 213.446C204.46 213.446 194.37 212.393 186.58 213.446C178.79 214.499 170.148 214.708 168.483 213.237C166.817 211.765 165.495 207.134 165.951 205.454C166.406 203.773 168.901 199.979 168.692 196.193C168.483 192.406 165.951 188.216 165.951 188.216L163.008 190.105C163.008 190.105 160.058 177.692 159.221 171.59C158.385 165.488 160.484 165.481 161.746 161.881C163.008 158.281 172.06 157.885 173.532 157.885C175.003 157.885 181.322 157.25 181.322 157.25L194.579 157.915Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M205.805 167.706C205.394 166.212 205.103 165.279 205.103 165.279",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M208.046 193.063C208.046 193.063 207.418 187.17 208.262 182.749C208.778 180.022 207.456 174.017 206.365 169.812",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M164.315 181.352C164.218 180.702 164.129 180.045 164.069 179.38",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M165.951 188.216C165.445 186.626 165.024 185.01 164.688 183.376",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M200.965 210.839C200.965 210.839 192.286 212.094 188.522 213.237",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M193.922 124.73C193.922 124.73 199.329 131.094 199.329 132.363C199.329 133.633 199.008 135.232 199.807 136.188C200.607 137.144 204.102 137.935 204.102 139.048C204.102 140.161 202.033 141.909 202.033 141.909C202.033 141.909 202.832 150.027 201.555 150.983C200.278 151.939 193.758 151.14 193.758 151.14C193.758 151.14 193.758 154.957 194.236 156.234C194.673 157.098 195.408 157.774 196.305 158.139C196.305 158.139 195.035 163.076 189.941 163.076C184.847 163.076 180.075 159.416 180.075 159.416C180.075 159.416 182.786 153.366 182.622 148.115C182.457 142.865 179.126 134.754 181.031 129.981C182.935 125.208 189.463 122.049 193.922 124.73Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M196.491 136.225C196.693 136.905 197.126 137.368 197.462 137.271C197.798 137.173 197.91 136.524 197.709 135.866C197.507 135.209 197.081 134.724 196.738 134.828C196.394 134.933 196.29 135.553 196.491 136.225Z",
    fill: "#1D1D1D"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M197.581 133.342C197.419 133.172 197.218 133.044 196.997 132.966C196.775 132.889 196.538 132.865 196.305 132.896C196.072 132.927 195.85 133.013 195.656 133.146C195.463 133.28 195.304 133.457 195.191 133.663",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M200.442 143.402C200.442 143.402 198.851 144.359 196.625 142.768",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M187.223 118.83C191.42 118.561 195.767 118.972 196.469 121.25C197.104 123.319 192.077 132.632 189.53 137.241C186.984 141.849 191.375 156.57 183.899 162.299C176.423 168.027 169.708 161.343 169.708 161.343C169.708 161.343 177.177 163.255 177.976 154.822C178.775 146.39 171.613 142.872 170.507 133.82C169.76 127.546 173.711 122.452 179.35 120.182C181.909 119.411 184.553 118.957 187.223 118.83Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M224.462 168.961C224.462 168.961 222.468 167.071 221.833 167.071C221.198 167.071 216.889 169.805 216.784 170.223C216.807 171.004 216.913 171.78 217.098 172.539C216.904 172.751 216.757 173.002 216.667 173.274C216.577 173.547 216.546 173.836 216.575 174.122V175.907L216.784 177.49C216.812 178.096 216.918 178.696 217.098 179.276C217.307 179.589 220.989 179.91 221.833 179.91H223.327L224.462 168.961Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M217.098 172.539L222.886 169.7",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M222.991 173.487L216.575 175.907",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M222.886 176.856L216.993 178.432",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M224.462 168.961L227.935 171.911C228.224 172.12 228.467 172.386 228.649 172.694C228.83 173.001 228.945 173.342 228.988 173.696C229.093 174.854 233.41 179.589 232.357 181.486C231.304 183.383 228.988 188.328 226.89 190.008C225.634 191.015 224.077 191.573 222.468 191.592L221.826 179.91H223.319L224.462 168.961Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M227.413 172.329C227.413 172.329 226.569 180.433 224.813 181.494C223.058 182.554 222.498 181.285 222.498 181.285",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M230.789 182.009C229.689 182.99 228.34 183.648 226.891 183.912C225.441 184.175 223.947 184.034 222.573 183.503",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M138.174 264.988L144.964 251.261C144.964 251.261 140.228 253.785 138.174 254.734C136.12 255.682 135.486 256.78 135.329 258.364C135.172 259.947 138.174 264.988 138.174 264.988Z",
    fill: "#DBC958",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M162.007 212.9C162.007 212.9 162.321 222.371 161.059 227.577C159.797 232.783 156.958 249.05 155.375 249.834C153.792 250.618 141.184 254.89 138.017 256.153C134.85 257.415 134.701 257.885 136.277 260.41C137.853 262.934 139.436 264.518 138.174 264.988C136.912 265.459 125.074 264.675 123.49 264.204C121.907 263.734 120.966 263.412 120.966 263.412C120.966 263.412 126.65 251.261 134.223 238.631C141.797 226.001 147.01 215.582 147.01 215.582C147.01 215.582 148.272 203.9 149.377 201.846C150.483 199.793 152.066 194.116 152.066 191.114C152.066 188.111 153.007 180.224 153.007 180.224C153.007 180.224 155.375 191.114 158.236 197.268C161.096 203.422 162.642 211.16 162.007 212.9Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M154.673 207.762C155.024 204.177 155.166 201.294 155.218 199.957",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M135.485 257.101C135.485 257.101 144.963 239.258 149.534 230.266C152.126 225.172 153.56 217.397 154.337 210.891",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M114.349 224.313C114.349 224.313 114.864 226.501 113.915 226.972C112.967 227.442 111.578 227.45 111.421 226.972C111.264 226.494 112.13 224.268 113.071 223.947C113.291 223.834 113.545 223.809 113.782 223.877C114.02 223.945 114.222 224.101 114.349 224.313Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M115.701 222.998L115.297 225.732C115.273 225.895 115.291 226.062 115.349 226.216C115.406 226.37 115.503 226.507 115.628 226.614C115.754 226.721 115.904 226.794 116.066 226.827C116.228 226.859 116.395 226.85 116.552 226.8L122.176 225.052C122.176 225.052 122.647 222.812 122.012 222.812C121.377 222.812 116.171 222.842 115.701 222.998Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M120.794 223.103L120.451 225.426",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M118.128 223.021L117.612 226.202",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M119.233 216.06C119.233 216.06 116.387 217.001 114.333 217.949C112.279 218.898 111.025 221.266 109.598 222.841C108.172 224.417 106.125 226.158 107.708 226.158C109.292 226.158 111.181 225.53 111.809 224.582C112.428 223.853 113.191 223.261 114.05 222.841C114.05 222.841 117.993 222.528 118.942 222.528C119.89 222.528 121.929 220.16 121.929 220.16",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M119.233 216.06C119.233 216.06 116.387 217.001 114.333 217.949C112.279 218.898 111.025 221.266 109.598 222.841C108.172 224.417 106.125 226.158 107.708 226.158C109.292 226.158 111.181 225.53 111.809 224.582C112.428 223.853 113.191 223.261 114.05 222.841C114.05 222.841 117.993 222.528 118.942 222.528C119.89 222.528 121.929 220.16 121.929 220.16",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M159.483 165.54C159.483 165.54 160.11 176.437 161.723 182.719C163.337 189 161.88 221.871 161.88 221.871C161.88 221.871 162.515 210.503 158.564 201.66C154.613 192.817 151.775 179.089 151.775 177.012C151.775 174.936 154.016 171.493 154.934 170.223C155.853 168.954 158.064 165.227 159.483 165.54Z",
    fill: "white",
    stroke: "#1D1D1D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_575_71672",
    x1: 2.45117,
    y1: 33.6488,
    x2: 303.579,
    y2: 375.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_575_71672",
    x1: 10.6802,
    y1: 127.285,
    x2: 26.8062,
    y2: 137.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_575_71672",
    x1: 235.888,
    y1: 63.5079,
    x2: 346.103,
    y2: 92.7384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_575_71672",
    x1: 296.507,
    y1: 147.294,
    x2: 373.016,
    y2: 167.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_575_71672",
    x1: 288.229,
    y1: 41.0995,
    x2: 327.924,
    y2: 41.0995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6A924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EB91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_575_71672",
    x1: 134.223,
    y1: 62.6191,
    x2: 141.26,
    y2: 64.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_575_71672",
    x1: 124.663,
    y1: 30.8913,
    x2: 140.081,
    y2: 35.5396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_575_71672",
    x1: 86.5566,
    y1: 23.1909,
    x2: 107.302,
    y2: 29.4443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_575_71672",
    x1: 84.4727,
    y1: 16.2747,
    x2: 86.6631,
    y2: 16.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_575_71672",
    x1: 106.678,
    y1: 86.1909,
    x2: 126.259,
    y2: 92.0935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_575_71672",
    x1: 103.959,
    y1: 77.1685,
    x2: 106.945,
    y2: 78.0675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_575_71672",
    x1: 64.9639,
    y1: 57.4431,
    x2: 69.4694,
    y2: 58.8006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_575_71672",
    x1: 54.022,
    y1: 21.1444,
    x2: 72.2342,
    y2: 26.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_575_71672",
    x1: 44.8877,
    y1: 66.2042,
    x2: 69.4542,
    y2: 73.6088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_575_71672",
    x1: 15.916,
    y1: 56.9651,
    x2: 21.0234,
    y2: 58.5052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_575_71672",
    x1: 5.31006,
    y1: 21.7568,
    x2: 22.9494,
    y2: 27.0701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_575_71672",
    x1: 10.7847,
    y1: 93.0025,
    x2: 35.3512,
    y2: 100.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_575_71672",
    x1: 82.5605,
    y1: 159.125,
    x2: 86.0659,
    y2: 160.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_575_71672",
    x1: 71.0737,
    y1: 121.011,
    x2: 89.9707,
    y2: 126.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_575_71672",
    x1: 161.514,
    y1: 133.088,
    x2: 162.583,
    y2: 133.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_575_71672",
    x1: 153.284,
    y1: 105.789,
    x2: 166.814,
    y2: 109.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_575_71672",
    x1: 166.07,
    y1: 36.366,
    x2: 190.637,
    y2: 43.7706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_575_71672",
    x1: 24.4976,
    y1: 195.154,
    x2: 27.277,
    y2: 195.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_575_71672",
    x1: 22.4214,
    y1: 188.268,
    x2: 24.5019,
    y2: 188.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_575_71672",
    x1: 12.6147,
    y1: 155.726,
    x2: 29.2263,
    y2: 160.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_575_71672",
    x1: 19.187,
    y1: 258.849,
    x2: 22.7632,
    y2: 259.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_575_71672",
    x1: 7.74512,
    y1: 220.885,
    x2: 27.1234,
    y2: 226.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_575_71672",
    x1: 111.958,
    y1: 270.403,
    x2: 126.323,
    y2: 274.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_575_71672",
    x1: 106.394,
    y1: 251.94,
    x2: 115.006,
    y2: 254.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_575_71672",
    x1: 23.0786,
    y1: 319.929,
    x2: 26.2274,
    y2: 320.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_575_71672",
    x1: 11.397,
    y1: 281.173,
    x2: 31.2672,
    y2: 287.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_575_71672",
    x1: 57.6743,
    y1: 173.995,
    x2: 82.2408,
    y2: 181.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_575_71672",
    x1: 117.5,
    y1: 209.248,
    x2: 119.266,
    y2: 209.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_575_71672",
    x1: 107.611,
    y1: 176.43,
    x2: 124.071,
    y2: 181.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_575_71672",
    x1: 101.935,
    y1: 224.567,
    x2: 103.399,
    y2: 225.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_575_71672",
    x1: 98.7681,
    y1: 225.359,
    x2: 100.351,
    y2: 226.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_575_71672",
    x1: 36.6567,
    y1: 186.505,
    x2: 38.1099,
    y2: 186.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_575_71672",
    x1: 31.3691,
    y1: 188.888,
    x2: 32.7895,
    y2: 191.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_575_71672",
    x1: 48.0244,
    y1: 166.952,
    x2: 49.0373,
    y2: 167.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_575_71672",
    x1: 44.3198,
    y1: 169.857,
    x2: 44.7549,
    y2: 171.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_575_71672",
    x1: 131.542,
    y1: 281.39,
    x2: 132.88,
    y2: 281.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_575_71672",
    x1: 127.837,
    y1: 281.39,
    x2: 129.401,
    y2: 283.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_575_71672",
    x1: 48.5474,
    y1: 282.712,
    x2: 49.7179,
    y2: 283.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_575_71672",
    x1: 44.5889,
    y1: 281.92,
    x2: 46.3358,
    y2: 283.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_575_71672",
    x1: 92.1582,
    y1: 310.989,
    x2: 93.7162,
    y2: 312.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_575_71672",
    x1: 88.7227,
    y1: 310.989,
    x2: 90.4743,
    y2: 312.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_575_71672",
    x1: 1.49365,
    y1: 336.846,
    x2: 1.49931,
    y2: 338.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_575_71672",
    x1: 114.097,
    y1: 214.26,
    x2: 235.549,
    y2: 351.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59D9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#598CD9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyIlustration);
export default __webpack_public_path__ + "static/media/why-ilustration.15c6d762f5d35f8d536cc7ff7bf7cbb5.svg";
export { ForwardRef as ReactComponent };